// extracted by mini-css-extract-plugin
export default {"skeleton-row":"d3d843"};